import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import {
    SERVER_URI,
} from "../utility/config";

function BlacklistedNumberCreatedMessage(props) {
    window.setTimeout(function () {
        props.handleClose();
    }, 1700);
    return (
        <div >
            <h2 className="message_title">Uusi numero lisätty estolistalle</h2>
        </div>
    );
}

function AddBlacklist(props) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({
        adminEmail: '',
        phoneNumber: '',
        reason: '',
    })
    const [doesExist, setDoesExist] = useState(false);
    let storage = window.localStorage;
    let userToken = storage.getItem("admin_token")

    const doesBlacklistedNumberExist = async (e) => {
        try {
            let phoneNumber = e.target.value
            let doesBlacklistedNumberExist = ''
            doesBlacklistedNumberExist = await axios.get(`${SERVER_URI}/is_blacklisted/${phoneNumber}`, { headers: { "Authorization": `Token ${userToken}` } })
            let exists = doesBlacklistedNumberExist.data.isBlacklisted
            if (exists === false) {
                setUserData({ ...userData, phoneNumber: phoneNumber })
                setDoesExist(false)
            } else {
                alert("Numero on jo estolistalla")
                setDoesExist(true)
            }
        } catch (e) {
            console.log("Error in blacklist", e)
        }

    }

    const onChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value })
    }

    //Submit
    const doSubmit = async (e) => {
        e.preventDefault()
        const dataToServer = {
            ...userData,
            phoneNumber: String(userData.phoneNumber),
            reason: String(userData.reason),
        }
        const dataToReducer = {
            ...userData,
            phoneNumber: String(userData.phoneNumber),
            reason: String(userData.reason),
        }
        if(doesExist === false) {
            try {
                let result = await axios.post(`${SERVER_URI}/add_to_blacklist/`, dataToServer, { headers: { "Authorization": `Token ${userToken}` } })
                props.dispatch({ type: "ADD_TO_BLACKLIST", data: { newBlacklistedNumber: dataToReducer, id: result.data.id, adminEmail: result.data.adminEmail } })
                setShow(!show);
            } catch (e) {
                console.log("Error in adding to blacklist", e)
            }
        }else {
            alert("Puhelinnumero ei ole kelvollinen.")
        }
    }

    return (
        <div className="popUp_card">
            <div className="popup-box">
                <div className="box">
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    {!show && (
                        <div>
                            <h2 className="popUp_title">Lisää numero estolistalle</h2>
                            <form className="add_driver_form" onSubmit={e => doSubmit(e)}>
                                <label className="label_add" htmlFor="reason">Syy:</label>
                                <input type="text" id="reason" name="reason" onChange={onChange} placeholder="Lisäyksen syy" required></input><span className="validity"></span> <br className="desktop-break" />
                                <label className="label_add" htmlFor="phoneNumber">Puhelinnumero:</label>
                                <input type="tel" id="phoneNumber" name="phoneNumber" placeholder="Puhelinnumero" onChange={doesBlacklistedNumberExist} required></input><span className="validity"></span><br className="desktop-break" />
                                <input type="submit" id="gradient_Button" value="Lisää tiedot" />
                            </form></div>
                    )}
                    {show && <BlacklistedNumberCreatedMessage handleClose={props.handleClose} />}
                </div>
            </div>
        </div>

    );
}

export default AddBlacklist